import { render, staticRenderFns } from "./customscheck.vue?vue&type=template&id=46892dec&scoped=true"
import script from "./customscheck.vue?vue&type=script&lang=js"
export * from "./customscheck.vue?vue&type=script&lang=js"
import style0 from "./customscheck.vue?vue&type=style&index=0&id=46892dec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46892dec",
  null
  
)

export default component.exports